import { LoadableLazy } from '@confluence/loadable';

export const PlanConsentDeepLink = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-StorageEnforcementBannerComponent-PlanConsentDeepLink" */ './PlanConsentDeepLink.tsx'
			)
		).PlanConsentDeepLink,
});
